<div
  class="modal-header"
  i18n="@@import-project-header"
>Projekt importieren</div>

<div class="modal-body">
  <div class="row mb-2 align-items-center">
    <div class="col-3">
      <span i18n="@@import-project-org-label">Ziel-Organisation:</span>
    </div>
    <div class="col">
      <p-select
        [options]="orgOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="this.targetOrgShort"
        [disabled]="this.isImporting"
        placeholder="Organisation auswählen"
        i18n-placeholder="@@import-project-org-placeholder"
      ></p-select>
    </div>
  </div>

  <div class="row mb-2 align-items-center">
    <div class="col-3">
      <span i18n="@@import-project-file-label">ZIP-Datei:</span>
    </div>
    <div class="col">
      <p-fileupload
        #fileupload
        name="file"
        mode="basic"
        chooseIcon="ri-file-upload-fill ri"
        accept=".zip"
        [auto]="false"
        [disabled]="this.isImporting"
        [chooseLabel]="this.chooseFileLabel"
        chooseStyleClass="p-button-secondary"
        (onSelect)="onFileSelected($event)"
        (onClear)="this.selectedFile = null"
      />
    </div>
  </div>

  @if (importFailureMessage) {
  <div class="alert alert-danger mt-2">
    <div>{{ importFailureMessage }}</div>
    @if (importFailureReport?.errors?.length) {
    <ul class="mb-0 mt-2">
      @for (issue of importFailureReport!.errors; track $index) {
      <li>{{ issue.itemType }}{{ issue.itemName ? ' – ' + issue.itemName : '' }}: {{ issue.message }}</li>
      }
    </ul>
    }
  </div>
  }
</div>

<div class="modal-footer">
  <p-button
    type="button"
    severity="secondary"
    [outlined]="true"
    label="Abbrechen"
    i18n-label="@@cancel"
    [disabled]="this.isImporting"
    (onClick)="this.cancel()"
  ></p-button>
  <p-button
    type="button"
    severity="primary"
    label="Projekt importieren"
    i18n-label="@@import-project-action"
    [disabled]="!this.canImport()"
    [loading]="this.isImporting"
    (onClick)="this.import()"
  ></p-button>
</div>
